type FirstLastArgs = {
  <T extends any>(list?: Array<T>): T | null;
  (list?: NodeList): Node | null;
};
/** @returns {*} the first element of an Array or NodeList */
export const first: FirstLastArgs = <T extends any>(
  list?: Array<T> | NodeList
): T | Node | null | undefined =>
  list == null || list.length === 0 ? undefined : list[0];

/** @returns {*} the last element of an Array or NodeList */
export const last: FirstLastArgs = <T extends any>(
  list?: Array<T> | NodeList
): T | Node | null | undefined =>
  list == null || list.length === 0 ? undefined : list[list.length - 1];
